import { Button, ButtonReversed } from "shared/components/Button";
import useWordBatchView from "features/homework/hooks/useWordBatchView";
import BatchTextInputSection from "./BatchTextInputSection";
import BatchFileInputSection from "./BatchFileInputSection";
import { word } from "shared/types/Report";
import LoadingWithProgressBar from "shared/components/Loading";
import Modal from "shared/components/Modal";
import { BatchBackdrop, BatchModal, BatchHeader, BatchTitle, BatchDesc, BatchBody, BatchSection, BatchFooter } from "../homeworkUi";

interface WordBatchViewProps {
    list:word[],
    setList:React.Dispatch<React.SetStateAction<word[]>>,
    path: string,
    isOpen: boolean,
    onCancelClickHandler: () => void
}

const WordBatchView = ({ isOpen, onCancelClickHandler, path, list, setList }: WordBatchViewProps) => {
    const { 
        fileList, 
        setFileList, 
        wordAudioList,
        setWordAudioList,
        exampleAudioList,
        setExampleAudioList,
        onChangeInputHandler, 
        onSaveClickHandler, 
        showProgress, 
        uploadFileName, 
        progress, 
        isSaveSucceed, 
        onSuccessModalConfirmHandler, 
        isOpenErrorModal, 
        onErrorModalCloseClickHandler,
        errorMessage
    } = useWordBatchView(list, setList, path, onCancelClickHandler);
    
    if (!isOpen) {
        return null;
    }

    return (
        <BatchBackdrop>
            <BatchModal>
                {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
                <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
                <Modal isOpen={isOpenErrorModal} onClose={onErrorModalCloseClickHandler} title="ERROR" content={errorMessage}/>
                <BatchHeader>
                    <BatchTitle>단어 일괄 등록</BatchTitle>
                    <BatchDesc>한 줄에 하나씩 입력하세요. 이미지와 음원은 선택 사항이며, 개수가 맞을 때만 함께 저장됩니다.</BatchDesc>
                </BatchHeader>
                <BatchBody>
                    <BatchSection>
                        <BatchTextInputSection 
                            label="단어" 
                            items={[{ label: "영어", name: "word" }, { label: "한국어", name: "kor" }]} 
                            onChangeHandler={onChangeInputHandler} 
                        />
                        <BatchFileInputSection 
                            label="이미지" 
                            accept="image"
                            fileList={fileList} 
                            setFileList={setFileList} 
                        />
                    </BatchSection>
                    <BatchSection>
                        <BatchFileInputSection 
                            label="단어 음원" 
                            accept="audio"
                            fileList={wordAudioList} 
                            setFileList={setWordAudioList} 
                        />
                        <BatchFileInputSection 
                            label="예문 음원" 
                            accept="audio"
                            fileList={exampleAudioList} 
                            setFileList={setExampleAudioList} 
                        />
                    </BatchSection>
                    <BatchSection>
                        <BatchTextInputSection 
                            label="예문" 
                            items={[{ label: "영어", name: "example" }, { label: "한국어", name: "example_kor" }]} 
                            onChangeHandler={onChangeInputHandler} 
                        />
                    </BatchSection>
                </BatchBody>
                <BatchFooter>
                    <ButtonReversed name="닫기" onButtonClick={onCancelClickHandler} />
                    <Button name="저장" onButtonClick={onSaveClickHandler} />
                </BatchFooter>
            </BatchModal>
        </BatchBackdrop>
    );
}

export default WordBatchView;
